<template>
    <div>
        <b-form-group label="Población" label-for="client">
            <b-form-input v-model="city" placeholder="Población" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        city: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localCity: this.city,
        }
    },
    watch: {
        city(newVal) {
            this.localCity = newVal
            this.$emit('update', { city: this.localCity })
        },
    },
}
</script>
